// import React from "react";
import "./index.css";
import React, { useEffect } from "react";

function TikTok() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.tiktok.com/embed.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="p-8 py-12 mt-16 max-w-full w-full overflow-hidden relative">
      <h2 className="text-3xl font-bold text-center mb-8 text-white">
        Our TikTok Feed
      </h2>
      <div className="iframe-container">
          <blockquote
            className="tiktok-embed"
            cite="https://www.tiktok.com/@xtremetunings.nl"
            data-unique-id="xtremetunings.nl"
            data-embed-type="creator"
            style={{ maxWidth: "780px", minWidth: "288px" }}
          >
            <section>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.tiktok.com/@xtremetunings.nl"
              >
                @xtremetunings.nl
              </a>
            </section>
          </blockquote>
      </div>
    </div>
  );
}

export default TikTok;

  /* <iframe
          src="https://widgets.sociablekit.com/tiktok-feed/iframe/25552028"
          frameBorder="0"
          width="100%"
          height="1000"
          title="TikTok Feed"
          className="w-full"
          loading="lazy"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe> */

  /* <div className="iframe-overlay"></div> */

